<template>
  <ul class="main-nav__navigation-box">
    <li v-for="item in menuData" :key="item.name" :class="{'current': isCurrentRoute(item.path)}">
      <!-- 有子菜单的情况 -->
      <template v-if="item.children && item.children.length > 0">
        <a 
          href="javascript:void(0);" 
          class="dropdown-toggle"
          :class="{'active': isParentActive(item)}">
          {{ item.meta.title }}
          <i class="fa fa-angle-down"></i>
        </a>
        <ul class="sub-menu">
          <li v-for="child in item.children" :key="child.name">
            <router-link :to="child.path" :class="{'active': isCurrentRoute(child.path)}">
              {{ child.meta.title }}
            </router-link>
          </li>
        </ul>
      </template>
      <!-- 没有子菜单的情况 -->
      <template v-else>
        <router-link :to="item.path" :class="{'active': isCurrentRoute(item.path)}">
          {{ item.meta.title }}
        </router-link>
      </template>
    </li>
  </ul>
</template>

<script>
import { articleApi } from "@/api/modules/article";

// 缓存菜单数据，避免每次渲染都重新请求
let cachedMenuData = null;
let lastFetchTime = 0;
const CACHE_DURATION = 1000 * 60 * 5; // 缓存5分钟

export default {
  name: 'MenuItem',
  data() {
    return {
      menuData: []
    }
  },
  async created() {
    await this.getMenu();
  },
  methods: {
    async getMenu() {
      try {
        const currentTime = Date.now();
        // 如果有缓存且缓存未过期，直接使用缓存数据
        if (cachedMenuData && (currentTime - lastFetchTime < CACHE_DURATION)) {
          this.menuData = cachedMenuData;
          return;
        }
        
        const response = await articleApi.getmenu();
        if (response.code === 200) {
          this.menuData = response.data;
          // 更新缓存和时间戳
          cachedMenuData = response.data;
          lastFetchTime = currentTime;
        }
      } catch (error) {
        console.error("获取菜单失败：", error);
      }
    },
    isCurrentRoute(path) {
      return this.$route.path === path;
    },
    isParentActive(item) {
      // 检查当前路由是否是该父菜单的任一子菜单路径
      if (item.children && item.children.length > 0) {
        return item.children.some(child => 
          this.$route.path === child.path || this.$route.path.startsWith(child.path + '/')
        );
      }
      return false;
    }
  }
}
</script>

<style scoped>
/* 使用原始样式类名，不添加新的样式 */
.main-nav__navigation-box {
  margin: 0;
  padding: 0;
  list-style: none;
}

.main-nav__navigation-box > li {
  float: left;
  padding: 18px 0;
  position: relative;
}

.main-nav__navigation-box > li + li {
  margin-left: 40px;
}

.main-nav__navigation-box > li > a {
  font-size: 16px;
  color: #7c7c7c;
  font-weight: 500;
  position: relative;
  display: inline-block;
  transition: all .4s ease;
}

.main-nav__navigation-box > li:hover > a {
  color: #f76649;
}

.main-nav__navigation-box > li > a::before {
  content: '';
  width: 100%;
  height: 2px;
  background-color: #f76649;
  position: absolute;
  bottom: -18px;
  left: 0;
  transform: scale(0, 1);
  transform-origin: left center;
  transition: transform .3s ease;
}

.main-nav__navigation-box > li:hover > a::before {
  transform: scale(1, 1);
}

.sub-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 991;
  display: none;
  min-width: 270px;
  background-color: #fff;
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.05);
  padding: 0;
  margin: 0;
  list-style: none;
}

.main-nav__navigation-box > li:hover > .sub-menu {
  display: block;
}

.sub-menu > li {
  display: block;
  position: relative;
}

.sub-menu > li > a {
  font-size: 16px;
  color: #7c7c7c;
  font-weight: 500;
  padding: 12px 30px;
  display: block;
  line-height: 26px;
  white-space: nowrap;
  transition: all .4s ease;
}

.sub-menu > li:hover > a {
  background-color: #f76649;
  color: #fff;
}

.dropdown-toggle::after {
  content: '\f107';
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  margin-left: 5px;
  font-size: 12px;
}

.main-nav__navigation-box > li.current > a,
.main-nav__navigation-box > li > a.active {
  color: #f76649 !important;  /* 选中时的文字颜色 */
}

.main-nav__navigation-box > li.current > a::after,
.main-nav__navigation-box > li > a.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #f76649;  /* 下划线颜色 */
}

/* 子菜单的选中样式 */
.sub-menu > li > a.active {
  color: #f76649 !important;
  background-color: #fff;
}
</style>
  